import React from 'react';
import '../styles/components/loader.scss';

const LoadingOverlay = () => {
	return (
		<div className='loading-overlay'>
			{/* <div className='spinner' /> */}
			<div className='loader'>
				<div className='loader--dot' />
				<div className='loader--dot' />
				<div className='loader--dot' />
				<div className='loader--dot' />
				<div className='loader--dot' />
				<div className='loader--dot' />
				<div className='loader--text' />
			</div>
		</div>
	);
};

export default LoadingOverlay;
